<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Creditors</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="3">
            <span style="font-size: 16px; font-weight: bold"
              >Total: {{ totalCredit }}</span
            >
          </v-col>
        </v-row>

        <v-row>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="7">
            <download-excel :data="creditors" :fields="fields" name="creditors">
              <v-icon color="green">mdi-file-excel</v-icon>
            </download-excel>
            <!-- start of table -->
            <v-data-table
              :items-per-page="pageItems"
              :headers="headers"
              :items="creditors"
              :search="search"
            >
              <!-- name template -->
              <template v-slot:item.ocrd.Name="{ item }">
                <v-btn
                  text
                  color="primary"
                  :to="`/statement/supplier/${item.ocrd.id}`"
                >
                  {{ item.ocrd.Name }}
                </v-btn>
              </template>
              <!-- end -->

              <!-- template -->
              <template v-slot:item.Balance="{ item }">{{
                item.Balance.toLocaleString()
              }}</template>
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn icon :to="`/report/creditors/${item.id}`">
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    pageItems: 100,
    headers: [
      { text: "Name", value: "ocrd.Name" },
      { text: "Current Debt", value: "Balance" },
      { text: "Action", value: "action" },
    ],
    fields: {
      Debtor: "ocrd.Name",
      Balance: "Balance",
    },
    creditors: [],
    Credit: null,
  }),
  computed: {
    totalCredit() {
      let total = 0;
      if (this.Credit) {
        total = this.Credit.toLocaleString();
      }
      return total;
    },
  },
  methods: {
    getCreditors() {
      const self = this;
      this.$store
        .dispatch("get", `/creditors`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.creditors = res.ResponseData.Debtors;
            self.Credit = res.ResponseData.TotalCredit;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getCreditors();
  },
};
</script>